import React from "react";

import {
  SelectedNetworkContext,
  NetworksContext,
} from "../NetworkContext/context";

import { useContextValue } from "./useContextValue";

export const NetworkProvider: React.FC = (props) => {
  const { networksValue, selectedNetworkValue } = useContextValue();

  return (
    <NetworksContext.Provider value={networksValue}>
      <SelectedNetworkContext.Provider value={selectedNetworkValue}>
        {props.children}
      </SelectedNetworkContext.Provider>
    </NetworksContext.Provider>
  );
};
